import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StyleEditConfig } from 'src/pages/AssortmentBuild/StyleEdit/StyleEdit.types';
import { TenantConfigViewData } from 'src/dao/tenantConfigClient';
import { Pivot } from 'src/worker/pivotWorker.types';
import { cacheCheckFitViewData } from 'src/pages/Hindsighting/StyleColorReview/StyleColorReview.slice';
import { ViewDataState } from 'src/types/Domain';

export interface StyleEditSlice {
  isConfigLoading: boolean;
  viewDefn: StyleEditConfig | Record<string, never>;
  rollupViewDefn: TenantConfigViewData | Record<string, never>;
  isDataLoading: boolean;
  liveData: Pivot;
  cachedData: Pivot;
  viewDataState: ViewDataState;
}

const initialState: StyleEditSlice = {
  isConfigLoading: false,
  viewDefn: {},
  rollupViewDefn: {},
  isDataLoading: false,
  viewDataState: ViewDataState.idle,
  cachedData: {
    tree: [],
    flat: [],
  },
  liveData: {
    tree: [],
    flat: [],
  },
};

const styleEditSliceReducer = createSlice({
  name: 'StyleEdit',
  initialState,
  reducers: {
    requestStyleEditConfigs(state) {
      state.isConfigLoading = true;
    },
    receiveStyleEditConfigs(state, action: PayloadAction<{ viewDefn: StyleEditConfig; rollup: TenantConfigViewData }>) {
      state.isConfigLoading = false;
      // @ts-ignore
      state.viewDefn = action.payload.viewDefn;
      // @ts-ignore
      state.rollupViewDefn = action.payload.rollup;
    },
    requestData(state) {
      state.viewDataState = ViewDataState.liveDataLoadingNoCache;
      state.cachedData = initialState.cachedData;
      state.liveData = initialState.liveData;
    },
    receiveCachedData(state, action: PayloadAction<Pivot>) {
      state.viewDataState = ViewDataState.liveDataLoadingFoundCache;
      state.cachedData = action.payload;
    },
    receiveLiveData(state, action: PayloadAction<Pivot>) {
      state.viewDataState = ViewDataState.liveDataReady;
      state.liveData = action.payload;
    },
    receiveError(_state, _action) {
      return initialState;
    },
    cleanupStyleEdit() {
      return initialState;
    },
  },
});

export const {
  requestStyleEditConfigs,
  receiveStyleEditConfigs,
  requestData,
  receiveCachedData,
  receiveLiveData,
  cleanupStyleEdit,
  receiveError,
} = styleEditSliceReducer.actions;

export function fetchStyleEditData(modelDefn: string) {
  return cacheCheckFitViewData(modelDefn, requestData, receiveCachedData, receiveLiveData, receiveError);
}

export default styleEditSliceReducer.reducer;
